<template>
  <section style="width: 100%" class="pa-2">
    <v-row
      v-if="kind === 'Operator_ProviderStorage'"
      class="d-block text-right pr-12"
    >
      <v-btn class="ma-4" color="primary" fab small dark @click="reload()">
        <v-icon>mdi-reload</v-icon>
      </v-btn>
      <v-dialog v-model="dialog" width="500" @click="open_dialog">
        <template v-slot:activator="{ attrs }">
          <v-btn
            class="ma-4"
            color="primary"
            fab
            small
            dark
            v-bind="attrs"
            @click="open_dialog"
            :disabled="!bucket.includes('operator') && !folderToUpload"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <v-form ref="form" v-model="valid" @submit.prevent="_onYes">
          <v-card>
            <v-card-title class="ma-2">Add Folder</v-card-title>
            <v-divider class="ma-2"></v-divider>
            <v-card-text class="ma-2" style="width: auto">
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="folder"
                    :rules="rules.nameRules"
                    label="Name"
                    required
                    autofocus
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="ma-2 text-right">
              <v-btn
                color="white"
                name="Cancel"
                class="text-right"
                @click="_onNo()"
                >CANCEL</v-btn
              >
              <v-btn color="primary" name="Add" class="text-right" type="submit"
                >ADD</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>
    <v-row v-else>
      <v-sheet
        title="Click to grap a file from your PC!"
        color="#c8dadf"
        width="100%"
        style="cursor: pointer; disaplay: grid"
        class="ma-0 pa-2"
        id="app"
        v-cloak
        @drop="addFile"
        @dragover.prevent
      >
        <v-dialog v-model="dialog" width="500" @click="open_dialog">
          <template v-slot:activator="{ attrs }">
            <v-btn
              class="ma-4 custom-btn"
              color="primary"
              right
              small
              absolute
              dark
              fab
              v-bind="attrs"
              @click="open_dialog"
              :disabled="!bucket.includes('operator') && !folderToUpload"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-form ref="form" v-model="valid" @submit.prevent="_onYes">
            <v-card>
              <v-card-title class="ma-2">Add Folder</v-card-title>
              <v-divider class="ma-2"></v-divider>
              <v-card-text class="ma-2" style="width: auto">
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="folder"
                      :rules="rules.nameRules"
                      label="Name"
                      :counter="400"
                      required
                      autofocus
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="ma-2 text-right">
                <v-btn
                  color="white"
                  name="Cancel"
                  class="text-right"
                  @click="_onNo()"
                  >CANCEL</v-btn
                >
                <v-btn
                  color="primary"
                  name="Add"
                  class="text-right"
                  type="submit"
                  >ADD</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-btn
          class="ma-4 custom-btn2"
          color="primary"
          small
          absolute
          dark
          fab
          @click="reload()"
        >
          <v-icon>mdi-reload</v-icon>
        </v-btn>
        <v-container class="custom_container text-center pa-1 mx-2">
          <v-row justify="center">
            <v-icon color="darken-2" size="35">mdi-download</v-icon>
          </v-row>

          <v-row align="center" justify="center">
            <span class="subtitle-2 text--darken-2"
              >Drag and drop to upload file!</span
            >
          </v-row>
        </v-container>
      </v-sheet>
    </v-row>
    <v-row
      class="mt-5 pa-2 pl-5 cursor-pointer"
      style="cursor: pointer"
      title="remove folder"
    >
      <v-icon
        v-if="folderToUpload"
        dark
        color="#757575"
        name="delete"
        @click="removeFolder()"
        >mdi-close-circle-outline</v-icon
      >
      <span v-if="folderToUpload" class="ml-3">
        <strong>{{ folderToUpload.path }}</strong>
      </span>
    </v-row>
  </section>
</template>
<script>
import { mapState } from "vuex";
import path from "path";

export default {
  props: ["bucket", "kind"],
  data: () => ({
    file_name: "",
    file_path: "",
    file: null,
    valid: true,
    uploaded_files: [],
    folder: "",
    dialog: false,
    rules: {
      nameRules: [(v) => !!v || "Name is required"],
    },
  }),
  computed: {
    ...mapState({
      user: (state) => state.user,
      folderToUpload: (state) => state.folderToUpload,
      paths_operator: (state) => state.paths_operator,
    }),
  },
  methods: {
    traverseFileTree: async function (item, _path) {
      const _this = this;
      _path = _path || "";

      if (item.isFile) {
        var str;
        var toUp;
        if (_this.bucket.includes("exchange")) {
          str = path.join(_this.folderToUpload.name, _path);
          str = path.join(str, item.name);
          toUp = path.join(_this.folderToUpload.path, _path);
          toUp = path.join(toUp, item.name);
        } else {
          if (!_this.folderToUpload) {
            str = path.join(_path, item.name);
            toUp = path.join(_path, item.name);
          } else {
            str = path.join(_this.folderToUpload.name, _path);
            str = path.join(str, item.name);
            toUp = path.join(_this.folderToUpload.path, _path);
            toUp = path.join(toUp, item.name);
          }
        }
        item.file(async function (file) {
          let params = {
            Bucket: _this.bucket,
            Key: str,
            Body: file,
            StorageClass: "INTELLIGENT_TIERING",
          };
          await _this.$store.dispatch("setUpload", params);
        });
        await _this.$store.dispatch("updateTree", {
          paths: toUp,
          name: str,
          key: "tree",
          StorageClass: "INTELLIGENT_TIERING",
        });
      } else if (item.isDirectory) {
        str = this.folderToUpload
          ? path.join(this.folderToUpload.name, _path + "/")
          : _path + "/";
        str = item.name ? path.join(str, item.name, "/") : str;
        toUp = this.folderToUpload
          ? path.join(this.folderToUpload.path, _path + "/")
          : _path + "/";
        toUp = item.name ? path.join(toUp, item.name, "/") : toUp;
        try {
          str = str.charAt(0) === "/" ? (str = str.substring(1)) : str;
          await this.$store.dispatch("setUpload", {
            Bucket: this.bucket,
            Key: str,
            Body: "",
            StorageClass: "INTELLIGENT_TIERING",
          });
          toUp = toUp.charAt(0) === "/" ? (toUp = toUp.substring(1)) : toUp;
          await _this.$store.dispatch("updateTree", {
            paths: toUp,
            name: str,
            key: "tree",
            StorageClass: "INTELLIGENT_TIERING",
          });

          // Get folder contents
          var dirReader = item.createReader();
          dirReader.readEntries(function (entries) {
            for (var i = 0; i < entries.length; i++) {
              _this.traverseFileTree(entries[i], _path + item.name + "/");
            }
          });
        } catch (err) {
          this.$store.dispatch("addMsgs", {
            name: "NetworkingError",
            action: "error",
            text: err,
            date: new Date().toISOString(),
          });
          this.dialog = false;
        }
      }
    },
    addFile: async function (event) {
      this.uploaded_files = [];
      event.preventDefault();
      var items = event.dataTransfer.items;
      await this.$store.commit("resetUpload");
      await this.$store.commit("resetMsgs");
      if (
        (this.bucket.includes("exchange") && !this.folderToUpload) ||
        (this.bucket.includes("provider") && !this.folderToUpload)
      ) {
        this.$store.dispatch("dispatchError", {
          text:
            { message: "Please select a provider" }.message.substr(0, 50) +
            "...",
          type: "danger",
        });
      } else {
        for (var i = 0; i < items.length; i++) {
          // webkitGetAsEntry is where the magic happens
          var item = items[i].webkitGetAsEntry();
          if (item) {
            this.traverseFileTree(item);
          }
        }
      }
    },
    async _onYes() {
      if (!this.folderToUpload && this.kind !== "OperatorStorage") {
        this.$store.dispatch("dispatchError", {
          text:
            { message: "Please select a provider or add one" }.message.substr(
              0,
              50
            ) + "...",
          type: "danger",
        });
      } else {
        switch (true) {
          case this.folder.length > 400:
            this.$store.dispatch("dispatchError", {
              text: { message: "Too long Name" }.message.substr(0, 50) + "...",
              type: "danger",
            });
            this.folder = "";
            this.dialog = false;
            break;
          case !this.folderToUpload && this.folder.length <= 400:
            var str = this.folder + "/";
            try {
              await this.$store.dispatch("setUpload", {
                Bucket: this.bucket,
                Key: str,
                Body: "",
                StorageClass: "INTELLIGENT_TIERING",
              });
              await this.$store.dispatch("updateTree", {
                paths: str,
                name: str,
                key: "tree",
                StorageClass: "INTELLIGENT_TIERING",
              });
              this.$refs.form.reset();
              this.dialog = false;
            } catch (err) {
              this.$store.dispatch("addMsgs", {
                name: "NetworkingError",
                action: "error",
                text: err,
                date: new Date().toISOString(),
              });
              this.dialog = false;
            }
            break;
          default:
            var str2 = this.folderToUpload.name;
            str2 = path.join(str2, this.folder) + "/";
            try {
              await this.$store.dispatch("setUpload", {
                Bucket: this.bucket,
                Key: str2,
                Body: "",
                StorageClass: "INTELLIGENT_TIERING",
              });
              let toUp = path.join(this.folderToUpload.path, this.folder) + "/";
              await this.$store.dispatch("updateTree", {
                paths: toUp,
                name: str2,
                key: "tree",
                StorageClass: "INTELLIGENT_TIERING",
              });
              this.$refs.form.reset();
              this.dialog = false;
            } catch (err) {
              this.$store.dispatch("addMsgs", {
                name: "NetworkingError",
                action: "error",
                text: err,
                date: new Date().toISOString(),
              });
              this.dialog = false;
            }
            break;
        }
      }
    },
    _onNo() {
      this.$refs.form.reset();
      this.dialog = false;
    },
    async reload() {
      window.location.reload();
    },
    async removeFolder() {
      await this.$store.dispatch("setFolderToUploadAction", "");
    },
    open_dialog() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.dialog = true;
    },
  },
};
</script>
<style>
.custom_container {
  outline: 2px dashed grey;
  width: auto !important;
  max-width: 100% !important;
}
.custom-btn {
  top: -10px;
}
.custom-btn2 {
  top: -10px;
  right: 70px !important;
}
</style>